// Polyfill needeed for Safari 13...
import EventTarget from '@ungap/event-target';

class Postbox extends EventTarget {
}

export default new Postbox();
